import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { ProposalInflowsSection } from 'Organisms/ProposalInflowsSection/ProposalInflowsSection';
import { ProposalInflowsSectionSkeleton } from 'Organisms/ProposalInflowsSection/ProposalInflowsSectionSkeleton';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('ProposalInflowsSectionContainer', () => ({
  root: {
    width: '100%',
  },
}));

export const ProposalInflowsSectionContainer = ({ relationship }) => {
  const {
    collection, loadingError, isInitializing,
  } = useLink(relationship);
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <DataContainer
      className={classes.root}
      component={ProposalInflowsSection}
      componentProps={{
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
      skeleton={ProposalInflowsSectionSkeleton}
    />
  );
};

ProposalInflowsSectionContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
